export default __webpack_public_path__ + "static/media/artwork-the-line.6ff35c6a.jpg";